const PRINCIPLES = [
  ["Evidence over opinion", "Every indicator links to the data behind it."],
  ["Confirmed vs inferred", "On-chain facts and heuristic links are never mixed."],
  ["No guarantees", "Signals inform research. They never certify a token as safe."],
  ["Read-only by design", "No wallet connection, no seed phrases, no private keys. Ever."],
];

export const About = () => (
  <section id="about" className="scroll-mt-20 border-b border-trace-line py-24 lg:py-32" data-testid="about-section">
    <div className="mx-auto grid max-w-7xl gap-16 px-4 sm:px-6 lg:grid-cols-[1fr_1.1fr] lg:px-8">
      <div>
        <p className="eyebrow">03 — About TRACE</p>
        <h2 className="mt-4 text-3xl font-semibold tracking-[-0.02em] text-white sm:text-4xl">On-chain data is public. Understanding it shouldn't be hard.</h2>
        <p className="mt-6 text-base leading-relaxed text-trace-muted">
          Solana data is open, but it is scattered across explorers, indexers and raw RPC responses. TRACE aims to make Solana
          blockchain data easier to investigate by bringing the most important information into one accessible interface,
          with clear explanations and honest limitations.
        </p>
        <img src="/trace-logo.png" alt="TRACE logo" width="512" height="512" loading="lazy"
          className="mt-10 hidden w-56 mix-blend-screen lg:block" />
      </div>
      <div className="space-y-8">
        <blockquote className="relative overflow-hidden rounded-2xl border border-trace-green/25 bg-trace-card p-8 sm:p-10" data-testid="mission-statement">
          <div className="absolute inset-y-0 left-0 w-1 bg-trace-green" />
          <p className="eyebrow text-trace-green">Mission</p>
          <p className="mt-4 font-heading text-2xl font-medium leading-snug tracking-tight text-white sm:text-3xl">
            "Make transparency the standard for on-chain trading."
          </p>
        </blockquote>
        <dl className="grid gap-4 sm:grid-cols-2">
          {PRINCIPLES.map(([t, d]) => (
            <div key={t} className="rounded-xl border border-trace-line bg-trace-panel p-5">
              <dt className="text-sm font-medium text-white">{t}</dt>
              <dd className="mt-1.5 text-sm text-trace-muted">{d}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  </section>
);
